module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10044.f13daef2.jpg";